import {environment} from '../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient, HttpContext} from '@angular/common/http';
import {SKIP_ERROR_INTERCEPTOR} from '../app/interceptors/error.interceptor';
import {Activity} from '../models/activity';

const API = environment.API

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(private http: HttpClient) {
  }

  getByUser(regionSlug: string) {
    let params = {region: regionSlug}
    let context = new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    return this.http.get<Activity>(`${API}/api/activities/user`, {params, context});
  }
}
